// extracted by mini-css-extract-plugin
export default {"container":"RelatedDisputes_container__0AxsU"};